import { SET_CREATE_BUTTON_VISIBILITY } from '../actions';

export default function createButtonReducer(state = { visible: true }, action) {
  switch (action.type) {
    case SET_CREATE_BUTTON_VISIBILITY:
      return {
        ...state,
        visible: action.payload
      };
    default:
      return state;
  }
} 